var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('h1',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Transaction")]),(_vm.meta)?_c('Widgets',{attrs:{"stats":_vm.meta}}):_vm._e()],1),(_vm.trx)?_c('div',{staticClass:"transactions"},[_c('Trx',{attrs:{"trx":_vm.trx}})],1):_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }